/**
 * @generated SignedSource<<a2ba2f2fce20f58dfbcbeae2fb437869>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type addMoqRulePanel_MoqRulesListQuery$variables = Record<PropertyKey, never>;
export type addMoqRulePanel_MoqRulesListQuery$data = {
  readonly moqRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly moqRuleID: number;
        readonly name: string;
      };
    }> | null;
  } | null;
};
export type addMoqRulePanel_MoqRulesListQuery = {
  response: addMoqRulePanel_MoqRulesListQuery$data;
  variables: addMoqRulePanel_MoqRulesListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      }
    ],
    "concreteType": "MoqRulesConnection",
    "kind": "LinkedField",
    "name": "moqRules",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MoqRulesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MoqRule",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "moqRuleID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "moqRules(first:200)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c9089847dd944782a8fc850c4360f396",
    "id": null,
    "metadata": {},
    "name": "addMoqRulePanel_MoqRulesListQuery",
    "operationKind": "query",
    "text": "query addMoqRulePanel_MoqRulesListQuery {\n  moqRules(first: 200) {\n    edges {\n      node {\n        id\n        moqRuleID\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "34658ec79c7dda9cdb545dd14e883e0a";

export default node;
